<template>
  <div>
    <div class="container-fluid">
      <div data-widget-group="group1">
        <ol class="breadcrumb">
          <li class="active">
            <router-link to="/admin">Dashboard</router-link>
          </li>
          <li class="active"><a href="#">Coupon Batch</a></li>
        </ol>
        <div class="panel-body locationform">
          <div v-if="ErrorMessage" class="alert-danger alert visibility" role="alert">
            {{ ErrorMessage }}
          </div>
          <div v-if="SuccessMessage" class="alert-info alert visibility" role="alert">
            {{ SuccessMessage }}
          </div>
          <form @submit.prevent="submitForm">
           <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Product List *</label>
                      <Select2SearchWithTokenPrefetch
                        :remoteControl="'kspgAPI/Product/search'"
                        :selectedOptionArray ="roleAlready"
                        @selectedData="ProductSelect"
                      ></Select2SearchWithTokenPrefetch>
                      <span v-if="errors.has('ProductSearch')">
                          {{ errors.first('ProductSearch') }}
                        </span>
                    </div>
                  </div>
                  <!-- <div class="col-md-2">
                    <div class="form-group">
                      <label>Applicable For Partner *</label>
                      <Select2SearchWithTokenPrefetch
                        :remoteControl="'kspgAPI/Partners/search'"
                        :selectedOptionArray ="roleAlready"
                        @selectedData="PartnerSelect"
                      ></Select2SearchWithTokenPrefetch>
                      <span v-if="errors.has('PartnerTypeValid')">
                          {{ errors.first('PartnerTypeValid') }}
                        </span>
                    </div>
                  </div> -->
                  <div class="col-md-6">
                     <div class="form-group">
                      <label>Applicable For Partner *</label><br>
                      
                      <input type="checkbox" id="selectAll" v-model="selectAll"> &nbsp;
                      <label for="selectAll">Select all partners</label> <br>
                      <div class="col-md-4" v-for="(value, key, index) in userList" :key="index">
                          <input type="checkbox" :id="key" v-model="PartnerMultiSelect"  :value="value.id"> &nbsp;
                          <label :for="key">{{value.id}}</label> 
                      </div>                      
                    
                      <span v-if="errors.has('multiSelectPartnerValid')">
                          {{ errors.first('multiSelectPartnerValid') }}
                        </span>
                     </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3">
                    <div class="form-group">
                      <label>Unique Batch Code *</label>
                      <input
                        type="Text"
                        class="form-control"
                        placeholder="Unique Batch Code"
                        v-on:keyup="getBatch"
                        v-model="batchData.batch_code"
                        v-validate="'required'"
                        name="batch_code"
                        data-vv-as="Unique Batch Code"
                        autocomplete="off"
                      />
                      <span v-if="errors.has('batch_code')">
                          {{ errors.first('batch_code') }}
                        </span>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label> Batch Start From *</label>
                      <input
                        type="number"
                        class="form-control"
                        placeholder="Batch Start From"
                        min="1"
                        step="1"
                        v-model="batchData.start_series"
                        name="start_series"
                        v-validate="'required'"
                        data-vv-as="Batch Start From"
                        autocomplete="off"
                      />
                       <span v-if="errors.has('start_series')">
                          {{ errors.first('start_series') }}
                        </span>
                    </div>
                  </div>
                  <div class="col-md-3">
                     <div class="form-group">
                      <label>Total Coupons *</label>
                      <input
                        type="number"
                        class="form-control"
                        placeholder="Coupons Count"
                        min="1"
                        step="1"
                        v-model="count_coupons"
                        name="count_coupons"
                         v-validate="'required'"
                         data-vv-as="Count Coupons"
                         autocomplete="off"
                      />
                     </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label> Batch End To *</label>
                      <input
                        type="number"
                        class="form-control"
                        placeholder="Batch End To"
                        min="1"
                        step="1"
                        v-model="batchData.end_series"
                        name="end_series"
                         v-validate="'required'"
                         data-vv-as="Batch End To"
                         readonly
                         autocomplete="off"
                      />
                      <span v-if="errors.has('end_series')">
                          {{ errors.first('end_series') }}
                        </span>
                    </div>
                  </div>
                </div>
                 <div class="row">
                  <div class="col-md-3">
                    <div class="form-group">
                        <label for="CouponDateSelectMonthTypeValid"> Select Coupon Generated Month *</label>
                      
                      <datepicker :minimumView="'month'"  :format="'MMM yyyy'"  :name="'CouponDateSelectMonthTypeValid'" :maximumView="'year'" :initialView="'year'" :bootstrapStyling="true" @selected="fromDateSelectMonth" ></datepicker>
                      <span v-if="errors.has('CouponDateSelectMonthTypeValid')">
                        {{ errors.first('CouponDateSelectMonthTypeValid')}}
                      </span>
                      </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                        <label for="from"> Prefix coupon code</label>                      
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Prefix coupon code"                        
                        v-model="batchData.Prefix"
                        name="Prefix"                       
                        autocomplete="off"
                      />
                      </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                        <label for="from"> Suffix coupon code</label>                      
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Suffix coupon code"                        
                        v-model="batchData.Suffix"
                        name="Suffix"                       
                        autocomplete="off"
                      />
                      </div>
                  </div>
                  <div class="col-md-3"  v-if="$can('Create','Loyalty::Coupons')">
                    <div class="form-group">
                    <button
                      class="btn-raised btn-primary btn fixcolorAs"
                      :disabled="loading"
                    >
                      <span
                        v-show="loading"
                        class="spinner-border spinner-border-sm"
                      ></span>
                      <span>Create Batch</span>
                    </button>
                    </div>
                  </div>
                </div>
               
                
          </form>
          <hr/>
         <div class="col-md-12 well" >
             <table
                class="table table-striped table-bordered"
                cellspacing="0"
                width="100%"
              >
                <thead>
                  <tr>
                    <th>#</th>
                   <th>Product Name</th>
                   <th>Description</th>
                   <th>Batch Code</th>
                   <th>Last Series</th>
                   <th>Last Update On</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- <tr class="odd gradeX"> -->
                  <tr
                    v-for="(item, index) in batch_data"
                    :key="item.id"
                    class="gradeC"
                  >
                    <td>{{ currentPage * pageSize + index + 1 }}</td>
                    <td>{{ item.ProductName }}</td>
                    <td>{{ item.Descriptions }}</td>
                    <td>{{ item.batch_code }}</td>
                    <td>{{ item.last_series }}</td>
                    <td>{{ item.modified_date ? item.modified_date : item.created_date | dateFormatReadable }}</td>
                  </tr>
                </tbody>
              </table>
              <div class="col-md-12">
                  <paginate
                  :page-count="TotalPage"
                  :click-handler="getAllBatch"
                  :prev-text="'Prev'"
                  :next-text="'Next'"
                  :container-class="'pagination'"
                >
                </paginate>
              </div>
         </div>
         
         
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Paginate from 'vuejs-paginate';
import Select2SearchWithTokenPrefetch from '../components/Select2SearchWithTokenPrefetch';
import commonServices from '../../services/common-services';
import moment from 'moment';
import UserService from '../../services/user.service';
import Datepicker from 'vuejs-datepicker';
function initialState() {
  return {
    batch_code: '',
    product_id:'',
    PartnerSelected:'',
  };
}
export default {
  name: 'createBatch',
  data() {
    return {
      couponCount:0,
      roleAlready:{},
      searchText:'',
      batch_data:[],
      page: 1,
      pageSize: 10,
      TotalPage: 1,
      currentPage:'',
      ErrorMessage: '',
      SuccessMessage: '',
      productSelected: '',
      PartnerSelected:'',
      PartnerMultiSelect:[],
      CouponDateSelectMonth:'',
      userList: [ 
            { "id": "Grinder", "name": "Grinder" }, 
            { "id": "Mechanics", "name": "Mechanics" }, 
            { "id": "Reborer", "name": "Reborer" }, 
            { "id": "ReborerPlusGrinder", "name": "ReborerPlusGrinder" }, 
            { "id": "Retailer", "name": "Retailer" }
        ],     
  
      loading: false,
      batchData: initialState(),
    };
  },
  components: {
    Select2SearchWithTokenPrefetch,
    Paginate,
    'Datepicker':Datepicker,
  },
  beforeCreate() {
    this.$store.commit('SET_LAYOUT', 'app-layout');
  },
  methods: {
    fromDateSelectMonth(date){      
      this.CouponDateSelectMonth = date.getFullYear()+'-'+(date.getMonth()+1);
      this.errors.remove('CouponDateSelectMonthTypeValid');  
    },
    // PartnerSelect(val){
    //   this.batchData.PartnerSelected = val;
    //   if(val){
    //     this.errors.remove('PartnerTypeValid');
    //   }
    // },
    ProductSelect(val) {
      this.productSelected = val;
      this.batchData.product_id = val;
      this.errors.remove('ProductSearch');   
      this.getAllBatch(1);  
    },
    getRequestParams(searchText, page, pageSize) {
      let params = {};

      if (searchText) {
        params['searchText'] = searchText;
      }

      if (page) {
        params['page'] = page - 1;
      }

      if (pageSize) {
        params['size'] = pageSize;
      }
      if(this.batchData.product_id){
        params['product_id'] = this.batchData.product_id;
      }
      return params;
    },
    getBatch() {
      if (this.batchData.batch_code.length > 2) {
        var param = {};
        param.batch_code = this.batchData.batch_code;
        param.product_id = this.productSelected;
        UserService.getMetod('kspgAPI/Batch/checkCode', param).then(
          (response) => {
            this.SuccessMessage = response.data.message;
            this.batchData.start_series = response.data.last_series;
          },
          (error) => {
            this.loading = false;
            this.ErrorMessage =
              (error.response &&
                error.response.data &&
                error.response.data.message) ||
              error.message ||
              error.toString();
          }
        );
      }
      setTimeout(() => (this.SuccessMessage = false), 5000);
      setTimeout(() => (this.ErrorMessage = false), 5000);
    },
    submitForm() {
      /* */
      
       this.$validator.validateAll().then((res) => {
         if (this.batchData.product_id == '') {
          this.errors.add({
            field: 'ProductSearch',
            msg: 'Please Select Product Number',
          });
          res = false;
        }
        if(!this.PartnerMultiSelect.length) {          
          this.errors.add({
            field: 'multiSelectPartnerValid',
            msg: 'Please Select Partner Type To Link Coupons To Product',
          });
          res = false;
        } else {
          this.batchData.PartnerSelected = this.PartnerMultiSelect;
        }
        if (this.CouponDateSelectMonth == '') {
          this.errors.add({
            field: 'CouponDateSelectMonthTypeValid',
            msg: 'Please Select Coupon Generated Month',
          });
          res = false;
        } else {
           this.batchData.CouponDateSelectMonth = this.CouponDateSelectMonth;
        }
        if (!res) {
          return false
        } else {
          let loader = this.$loading.show();
          UserService.postMetod('kspgAPI/Batch/create', this.batchData).then(
            (response) => {
              this.SuccessMessage = response.data.message;
              this.loading = false;
              // on success reset values
              if (response.data.status) {
                this.resetWindow();
                /*Clear Validation */
                 this.$nextTick(() => {
                    this.errors.clear();
                    this.$nextTick(() => {
                        this.$validator.reset();
                    });
                });
              }
            },
            (error) => {
              this.loading = false;

              this.ErrorMessage =
                (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                error.message ||
                error.toString();
            }
          );
          setTimeout(() => {loader.hide()}, 1000)
        }
      });
      this.getAllBatch(1); 
      // Hide Messages
      setTimeout(() => (this.ErrorMessage = false), 5000);
      setTimeout(() => (this.SuccessMessage = false), 5000);  
    },
    getAllBatch(pageNum) {
      this.skyloStart();
      let loader = this.$loading.show();
      const params = this.getRequestParams(
        this.searchText,
        pageNum,
        this.pageSize
      );
      /*bajajAPI/user/list*/
      commonServices
        .get('kspgAPI/Batch/list', params)
        .then((response) => {
          const {
            batch_data,
            totalItems,
            currentPage,
            TotalPage,
          } = response.data;
          this.batch_data = batch_data;
          this.TotalPage = TotalPage;
          this.currentPage = parseInt(currentPage);
        })
        .catch((e) => {
           if(e.response.data.error == "Invalid API key "){
             loader.hide()
             this.$router.push({ name: 'login'});
          }
        });
      this.skyloEnd();
      setTimeout(() => {loader.hide()}, 500)
    },
    resetWindow: function () {
      Object.assign(this.$data.batchData, initialState());
    },
  },
  computed:{
    selectAll:{
       get: function () {
                return this.userList ? this.PartnerMultiSelect.length == this.userList.length : false;
            },
        set: function (value) {
            var PartnerMultiSelect = [];

            if (value) {
                this.userList.forEach(function (user) {
                    PartnerMultiSelect.push(user.id);
                });
            }

            this.PartnerMultiSelect = PartnerMultiSelect;
        }
    },

    count_coupons:{
        get: function () {
          return this.couponCount;
          // return this.batchData.end_series;
        },
        set: function (newValue) {
         this.couponCount = newValue;
          this.batchData.end_series=parseInt(this.batchData.start_series) + parseInt(newValue);
        }
      
    }
  },
  created() {},
  mounted() {this.getAllBatch(1);},
  filters: {
    dateFormatReadable(input_date) {
      if (!input_date) {
        return input_date;
      }
      return moment(String(input_date)).format('DD-MM-YYYY');
    },
  },
};
</script>
<style scoped>
.visibility {
  visibility: visible !important;
}
</style>
